import { render, staticRenderFns } from "./DepositTest.vue?vue&type=template&id=02d038cb&scoped=true&"
import script from "./DepositTest.vue?vue&type=script&lang=js&"
export * from "./DepositTest.vue?vue&type=script&lang=js&"
import style0 from "./DepositTest.vue?vue&type=style&index=0&id=02d038cb&lang=scss&scoped=true&"
import style1 from "./DepositTest.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d038cb",
  null
  
)

export default component.exports